import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { googleSession, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { FullScreen } from "@/components/FullScreen";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useI18n();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { navigate("/login"); return; }

    // Il nonce deve coincidere con quello salvato da questo browser all'avvio del giro
    // OAuth: un link ricevuto da terzi porta con sé un `state` che qui non risulta,
    // e viene scartato prima di scambiare il session_id.
    const returned = new URLSearchParams(location.search).get("state") || "";
    let expected = "";
    try { expected = sessionStorage.getItem("vs_oauth_state") || ""; } catch { /* noop */ }
    try { sessionStorage.removeItem("vs_oauth_state"); } catch { /* noop */ }
    if (!returned || !expected || returned !== expected) {
      toast.error(t("google_login_failed"));
      window.history.replaceState({}, "", "/login");
      navigate("/login");
      return;
    }

    googleSession(sid, returned)
      .then((user) => {
        setUser(user);
        window.history.replaceState({}, "", "/app");
        navigate("/app");
      })
      .catch((err) => {
        // Mostra il motivo reale quando c'è: il 409 "esiste già un account con password"
        // è azionabile, mentre un generico "riprova" manderebbe l'utente in loop.
        const detail = err?.response?.data?.detail;
        toast.error(detail ? formatApiErrorDetail(detail) : t("google_login_failed"));
        navigate("/login");
      });
  }, [location.hash, location.search, navigate, setUser, t]);

  return <FullScreen text="Accesso in corso…" />;
}
